import React from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";

interface BreadCrumbProps {
  title: string;
  pageTitle: string;
  url?: string;
}

const BreadCrumb = ({ title, pageTitle, url }: BreadCrumbProps) => {
  return (
    <React.Fragment>
      <Row className="mt-n1">
        <Col xs={12}>
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0 font-primary fs-16 fw-semibold text-black2D">
              {title}
            </h4>

            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link
                    to={url ? url : "#"}
                    className="text-black2D font-primary fs-14 fw-normal"
                  >
                    {pageTitle}
                  </Link>
                </li>
                <li className="breadcrumb-item active text-grey89 font-primary fs-14 fw-normal">
                  {title}
                </li>
              </ol>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default React.memo(BreadCrumb);
